/* global fetch */
import _ from 'lodash'
import url from 'url'
import * as CONTENT_TYPE from 'common/constant/content-type'
import * as HTTP_METHOD from 'common/constant/http-method'
import { Auth, Signer } from 'aws-amplify'


const API_URL = process.env.IS_OFFLINE === 1
  ? ''
  : process.env.API_URL

let accessToken

const getAccessToken = async () => {
  if (accessToken) {
    return accessToken
  }
  const session = await Auth.currentSession()
  accessToken = `Bearer ${session.getIdToken().getJwtToken()}`
  return accessToken
}

const createFormattedUrl = (apiUrl, query) => {
    const parsedUrl = url.parse(apiUrl) // eslint-disable-line
    const parsedAPIUrl = url.parse(API_URL) // eslint-disable-line

  const formattedUrl = url.format({
    ...parsedAPIUrl,
    ..._.pick(parsedUrl, ['href', 'path', 'pathname']),
    query: _.pickBy(query, _.identity)
  })
  if (+process.env.IS_OFFLINE === 1) {
    return `https://local${API_URL}${formattedUrl}`
  } else {
    return `https://${API_URL}${formattedUrl}`
  }
}

// eslint-disable-next-line complexity
const parseResponse = async (response, returnHeaders) => {
  const json = await response.json()
  if (response.ok) {
    if (returnHeaders) {
      return response
    }

    return json
  } else {
    throw new Error(json.error)
  }
}

async function createSignedRequest(url, method, body = null, queryStrings = {}){

  url = createFormattedUrl(url, queryStrings);
  
  const essentialCredentials = Auth.essentialCredentials(await Auth.currentCredentials());
   
  const params = { method, url, data:body};
  const credentials = {
      secret_key: essentialCredentials.secretAccessKey,
      access_key: essentialCredentials.accessKeyId,
      session_token: essentialCredentials.sessionToken,
  };

  const serviceInfo = {region: process.env.AWS_REGION, service: "execute-api"};

  return Signer.sign(params, credentials, serviceInfo);
}


export const postJson = async (inputUrl, headers = {}, body = {}, returnHeaders = false) => {

  body = body === 'string' ? body : JSON.stringify(body);
  var signedRequest = await createSignedRequest(inputUrl, HTTP_METHOD.POST, body, {});

  const response = await fetch(createFormattedUrl(inputUrl, null), {
    body: body,
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers: signedRequest.headers,
    method: HTTP_METHOD.POST
  });

  const parsed = await parseResponse(response, returnHeaders)
  return parsed
}


export const getJson = async (inputUrl, headers = {}, queryStrings = {}, returnStatus = false) => {

  var signedRequest = await createSignedRequest(inputUrl, HTTP_METHOD.GET, null, queryStrings);

  const response = await fetch(createFormattedUrl(inputUrl, queryStrings), {
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers: signedRequest.headers,
    method: HTTP_METHOD.GET
  })

  return await response.json()
}


export const deleteJson = async (inputUrl, headers = {}, body = {}, queryStrings = {}) => {

  body = body === 'string' ? body : JSON.stringify(body);
  var signedRequest = await createSignedRequest(inputUrl, HTTP_METHOD.DELETE, body, queryStrings);

  const response = await fetch(createFormattedUrl(inputUrl, queryStrings), {
    body: body,
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers: signedRequest.headers,
    method: HTTP_METHOD.DELETE
  })

  const parsed = await parseResponse(response, false)

  return parsed
}


export const getText = async (inputUrl, headers = {}, queryStrings = {}, returnStatus = false) => {
  const response = await fetch(createFormattedUrl(inputUrl, queryStrings), {
    credentials: HTTP_METHOD.CREDENTIALS_INCLUDE,
    headers: {
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: CONTENT_TYPE.JSON,
      [CONTENT_TYPE.AUTHORIZATION_HEADER]: await getAccessToken(),
      ...headers
    },
    method: HTTP_METHOD.GET
  })

  const bodyResponse = await response.text()
  return bodyResponse
}


export const putFile = async (inputUrl, file, contentType, headers = {}) => {
  const response = await fetch(inputUrl, {
    body: file,
    headers: {
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: contentType,
      [CONTENT_TYPE.AUTHORIZATION_HEADER]: await getAccessToken(),
      ...headers
    },
    method: HTTP_METHOD.PUT
  })

  return response
}


export const getFile = async (inputUrl) => {
  const response = await fetch(inputUrl, {
    method: HTTP_METHOD.GET,
    headers: {
      [CONTENT_TYPE.ACCESS_CONTROL_ALLOW_ORIGIN]: ['https://localhost:4000', 'https://*.wdverify.com'],
      [CONTENT_TYPE.CONTENT_TYPE_HEADER]: CONTENT_TYPE.JSON
    }
  })
  const bodyResponse = await response.json()
  return bodyResponse
}